export const securityUrls = {
  auth: {
    SIGNUP: '/public/iam/user/register',
    TOKEN: '/public/iam/user/login',
    TOKEN_REFRESH: '/public/iam/user/token/refresh',
    GOOGLE: '/u/social/auth/google',
    FACEBOOK: '/u/social/auth/facebook',
    PHONE: '/u/social/auth/phone',
    FORGOT_PASSWORD: '/u/password/forgot',
    RESET_PASSWORD: '/u/password/reset'
  }
}

export const learnercollabUrls = {
  users: {
    REGISTER: '/public/iam/user/register',
    UPDATE: '/user/details',
    DETAILS: '/user/details',
    FEED: '/user/feed'
  }
}

export const fileUploadsUrls = {
  UPLOAD: '/files/upload'
}

export type AuthUrlType = keyof typeof securityUrls.auth
export type UserUrlType = keyof typeof learnercollabUrls.users
